import { createFileRoute } from "@tanstack/react-router"
import CoreAutomationsPage from "@/components/coreAutomations/CoreAutomationsPage"

export const Route = createFileRoute("/core/automations")({
  component: CoreAutomationsPage
})
